export default __webpack_public_path__ + "static/18-ea1e0f16a6f20e546fe9203d1e65fc76.png";